export const LEAD_BANNER_TEXTS = {
  submitButton: 'Подобрать с экспертом',
} as const;
